const SCREENSHOT_VIEWS = {
  offersList: {
    title: 'Panel Principal de Ofertas Laborales',
    status: 'Filtros Avanzados Activos',
    content: `
      <div style="background: #ffffff; border-radius: 8px; border: 1px solid #dce3ed; padding: 1.25rem; margin-bottom: 1.25rem;">
        <div style="font-size: 0.88rem; font-weight: 700; color: #0f2b48; margin-bottom: 0.85rem; display: flex; align-items: center; gap: 0.5rem;">
          <span>🔍 Filtros de Búsqueda Avanzada</span>
        </div>
        <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.6rem; font-size: 0.8rem; color: #718096;">
          <div style="padding: 0.5rem 0.75rem; border: 1px solid #cbd5e1; border-radius: 6px; background: #fff;"># Folio</div>
          <div style="padding: 0.5rem 0.75rem; border: 1px solid #cbd5e1; border-radius: 6px; background: #fff;">👤 Nombre</div>
          <div style="padding: 0.5rem 0.75rem; border: 1px solid #cbd5e1; border-radius: 6px; background: #fff;">💼 Apellido Paterno</div>
          <div style="padding: 0.5rem 0.75rem; border: 1px solid #cbd5e1; border-radius: 6px; background: #fff;">💼 Apellido Materno</div>
          <div style="padding: 0.5rem 0.75rem; border: 1px solid #cbd5e1; border-radius: 6px; background: #fff;">🏢 División ▾</div>
          <div style="padding: 0.5rem 0.75rem; border: 1px solid #cbd5e1; border-radius: 6px; background: #fff;">🏬 Área ▾</div>
          <div style="padding: 0.5rem 0.75rem; border: 1px solid #cbd5e1; border-radius: 6px; background: #fff;">👁️ Estado (Activo) ▾</div>
          <div style="padding: 0.5rem 0.75rem; background: #0f2b48; color: #fff; font-weight: 700; border-radius: 6px; text-align: center; cursor: pointer;">🔍 Consultar</div>
        </div>
      </div>

      <div style="background: #ffffff; border-radius: 8px; border: 1px solid #dce3ed; overflow-x: auto;">
        <table style="width: 100%; border-collapse: collapse; font-size: 0.84rem; text-align: left;">
          <thead style="background: #f8fafc; color: #0f2b48; border-bottom: 1px solid #dce3ed;">
            <tr>
              <th style="padding: 0.75rem 1rem;">Folio</th>
              <th style="padding: 0.75rem 1rem;">Nombre</th>
              <th style="padding: 0.75rem 1rem;">Tipo Oferta</th>
              <th style="padding: 0.75rem 1rem;">Estado Oferta</th>
              <th style="padding: 0.75rem 1rem;">Firmas</th>
              <th style="padding: 0.75rem 1rem;">Editar</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border-bottom: 1px solid #edf2f7;">
              <td style="padding: 0.75rem 1rem; color: #0f2b48; font-weight: 600;">20260719_000003</td>
              <td style="padding: 0.75rem 1rem;">Mario Dias Garcia</td>
              <td style="padding: 0.75rem 1rem;">Externa</td>
              <td style="padding: 0.75rem 1rem;">Nueva</td>
              <td style="padding: 0.75rem 1rem; color: #718096;">Sin firmas registradas</td>
              <td style="padding: 0.75rem 1rem; color: #1d6bc0; cursor: pointer;">✏️</td>
            </tr>
            <tr style="border-bottom: 1px solid #edf2f7;">
              <td style="padding: 0.75rem 1rem; color: #0f2b48; font-weight: 600;">20260528_000002</td>
              <td style="padding: 0.75rem 1rem;">Mateo Dias lopez</td>
              <td style="padding: 0.75rem 1rem;">Interna</td>
              <td style="padding: 0.75rem 1rem;">Nueva</td>
              <td style="padding: 0.75rem 1rem; color: #718096;">Sin firmas registradas</td>
              <td style="padding: 0.75rem 1rem; color: #1d6bc0; cursor: pointer;">✏️</td>
            </tr>
            <tr>
              <td style="padding: 0.75rem 1rem; color: #0f2b48; font-weight: 600;">20260527_000001</td>
              <td style="padding: 0.75rem 1rem;">Alejandro Lopez Luna</td>
              <td style="padding: 0.75rem 1rem;">Externa</td>
              <td style="padding: 0.75rem 1rem; font-weight: 700; color: #0f2b48;">Firmas</td>
              <td style="padding: 0.75rem 1rem;">
                <span style="display: inline-flex; gap: 4px; align-items: center;">
                  <span style="background: #10b981; color: #fff; width: 20px; height: 20px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.65rem; font-weight: 800;">✓</span>
                  <span style="background: #f59e0b; color: #fff; width: 20px; height: 20px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.65rem;">🕒</span>
                  <span style="background: #1d6bc0; color: #fff; width: 20px; height: 20px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.65rem;">👤</span>
                </span>
              </td>
              <td style="padding: 0.75rem 1rem; color: #1d6bc0; cursor: pointer;">✏️</td>
            </tr>
          </tbody>
        </table>
      </div>
    `
  },
  organigram: {
    title: 'Generador de Organigrama de Empleados',
    status: 'Árbol Jerárquico Generado',
    content: `
      <div style="background: #ffffff; border-radius: 8px; border: 1px solid #dce3ed; padding: 1.5rem; text-align: center;">
        <div style="font-size: 0.95rem; font-weight: 700; color: #0f2b48; margin-bottom: 1.5rem;">Estructura de Reporte Jerárquico</div>
        
        <div style="display: flex; flex-direction: column; align-items: center; gap: 1.5rem; overflow-x: auto; padding: 1rem 0;">
          <!-- Node Root -->
          <div style="background: #1d6bc0; color: #fff; padding: 0.75rem 1.5rem; border-radius: 8px; font-size: 0.85rem; width: 220px; box-shadow: 0 4px 12px rgba(29,107,192,0.2);">
            <div style="font-size: 0.7rem; text-transform: uppercase; font-weight: 700; opacity: 0.9;">Empleado #13323</div>
            <div style="font-weight: 800; font-size: 0.95rem; margin: 2px 0;">Mateo Dias lopez</div>
            <div style="font-size: 0.75rem; opacity: 0.85;">Directo</div>
          </div>
          
          <div style="width: 2px; height: 20px; background: #cbd5e1;"></div>
          
          <!-- Node SubDirector -->
          <div style="background: #1d6bc0; color: #fff; padding: 0.75rem 1.5rem; border-radius: 8px; font-size: 0.85rem; width: 220px; box-shadow: 0 4px 12px rgba(29,107,192,0.2);">
            <div style="font-size: 0.7rem; text-transform: uppercase; font-weight: 700; opacity: 0.9;">Empleado #13326</div>
            <div style="font-weight: 800; font-size: 0.95rem; margin: 2px 0;">Dario Navarro Calderon</div>
            <div style="font-size: 0.75rem; opacity: 0.85;">SubDirector C</div>
          </div>

          <div style="width: 2px; height: 20px; background: #cbd5e1;"></div>

          <!-- Children Grid -->
          <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.75rem; width: 100%; max-width: 800px;">
            <div style="background: #fff; border: 1px solid #1d6bc0; border-top: 4px solid #1d6bc0; border-radius: 6px; padding: 0.5rem; font-size: 0.75rem;">
              <div style="color: #1d6bc0; font-weight: 700;">Carmelo Audevez</div>
              <div style="color: #718096;">Empleado 1</div>
            </div>
            <div style="background: #fff; border: 1px solid #1d6bc0; border-top: 4px solid #1d6bc0; border-radius: 6px; padding: 0.5rem; font-size: 0.75rem;">
              <div style="color: #1d6bc0; font-weight: 700;">Mario Dias Audevez</div>
              <div style="color: #718096;">Empleado 2</div>
            </div>
            <div style="background: #fff; border: 1px solid #1d6bc0; border-top: 4px solid #1d6bc0; border-radius: 6px; padding: 0.5rem; font-size: 0.75rem;">
              <div style="color: #1d6bc0; font-weight: 700;">Karla Lopez Dias</div>
              <div style="color: #718096;">Empleado 3</div>
            </div>
            <div style="background: #fff; border: 1px solid #1d6bc0; border-top: 4px solid #1d6bc0; border-radius: 6px; padding: 0.5rem; font-size: 0.75rem;">
              <div style="color: #1d6bc0; font-weight: 700;">Juan Mares Lopez</div>
              <div style="color: #718096;">Empleado 4</div>
            </div>
          </div>
        </div>

        <div style="display: flex; gap: 0.75rem; justify-content: flex-start; margin-top: 1rem;">
          <div style="padding: 0.5rem 1rem; background: #0f2b48; color: #fff; font-size: 0.8rem; font-weight: 700; border-radius: 6px; cursor: pointer;">📥 Exportar</div>
          <div style="padding: 0.5rem 1rem; background: #0f2b48; color: #fff; font-size: 0.8rem; font-weight: 700; border-radius: 6px; cursor: pointer;">🖨️ Imprimir</div>
        </div>
      </div>
    `
  },
  offerDetail: {
    title: 'Detalle de Oferta & Empleo Actual vs Ofertado',
    status: 'Folio: 20260527_000001',
    content: `
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
        <div style="background: #ffffff; border-radius: 8px; border: 1px solid #dce3ed; padding: 1.25rem;">
          <div style="font-size: 0.9rem; font-weight: 700; color: #0f2b48; margin-bottom: 0.85rem; display: flex; align-items: center; gap: 0.4rem;">
            <span>💼 Empleo Actual</span>
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; font-size: 0.82rem;">
            <div><label style="color: #718096; display: block;">Empresa</label><input value="empresa uno" readonly style="width:100%; padding:0.4rem; border:1px solid #cbd5e1; border-radius:4px;"></div>
            <div><label style="color: #718096; display: block;">Ubicación</label><input value="mty" readonly style="width:100%; padding:0.4rem; border:1px solid #cbd5e1; border-radius:4px;"></div>
            <div><label style="color: #718096; display: block;">Puesto</label><input value="2" readonly style="width:100%; padding:0.4rem; border:1px solid #cbd5e1; border-radius:4px;"></div>
            <div><label style="color: #718096; display: block;">Sueldo Actual</label><input value="$ 452.98" readonly style="width:100%; padding:0.4rem; border:1px solid #cbd5e1; border-radius:4px; font-weight:700;"></div>
          </div>
        </div>

        <div style="background: #ffffff; border-radius: 8px; border: 1px solid #dce3ed; padding: 1.25rem;">
          <div style="font-size: 0.9rem; font-weight: 700; color: #0f2b48; margin-bottom: 0.85rem; display: flex; align-items: center; gap: 0.4rem;">
            <span>💼 Empleo Ofertado</span>
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; font-size: 0.82rem;">
            <div><label style="color: #718096; display: block;">División</label><input value="Division cinco" readonly style="width:100%; padding:0.4rem; border:1px solid #cbd5e1; border-radius:4px;"></div>
            <div><label style="color: #718096; display: block;">Área</label><input value="area cuatro" readonly style="width:100%; padding:0.4rem; border:1px solid #cbd5e1; border-radius:4px;"></div>
            <div><label style="color: #718096; display: block;">Ubicación</label><input value="ubicacion pro" readonly style="width:100%; padding:0.4rem; border:1px solid #cbd5e1; border-radius:4px;"></div>
            <div><label style="color: #718096; display: block;">Sueldo Ofertado</label><input value="$ 888.80" readonly style="width:100%; padding:0.4rem; border:1px solid #1d6bc0; border-radius:4px; font-weight:700; color:#1d6bc0;"></div>
          </div>
        </div>
      </div>
    `
  },
  benefitsTable: {
    title: 'Desglose de Beneficios, Prestaciones & Retenciones',
    status: 'Fórmulas Calculadas',
    content: `
      <div style="background: #ffffff; border-radius: 8px; border: 1px solid #dce3ed; padding: 1.25rem; overflow-x: auto;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <span style="font-size: 0.95rem; font-weight: 700; color: #0f2b48;">🎁 Matriz de Beneficios y Prestaciones</span>
          <span style="padding: 0.4rem 0.85rem; background: #0f2b48; color: #fff; font-size: 0.78rem; font-weight: 700; border-radius: 6px;">+ Agregar Beneficio</span>
        </div>

        <table style="width: 100%; border-collapse: collapse; font-size: 0.82rem; text-align: left;">
          <thead style="background: #f8fafc; color: #0f2b48; border-bottom: 1px solid #dce3ed;">
            <tr>
              <th style="padding: 0.6rem 0.8rem;">BENEFICIO</th>
              <th style="padding: 0.6rem 0.8rem;">TIPO</th>
              <th style="padding: 0.6rem 0.8rem;">DESCRIPCIÓN</th>
              <th style="padding: 0.6rem 0.8rem;">ACTUAL</th>
              <th style="padding: 0.6rem 0.8rem;">OFERTADO</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border-bottom: 1px solid #edf2f7;">
              <td style="padding: 0.6rem 0.8rem; font-weight: 700;">Sueldo Base</td>
              <td style="padding: 0.6rem 0.8rem;">Sueldo + Prestaciones</td>
              <td style="padding: 0.6rem 0.8rem;">salario</td>
              <td style="padding: 0.6rem 0.8rem;">$425.98</td>
              <td style="padding: 0.6rem 0.8rem; font-weight: 700; color: #1d6bc0;">$888.80</td>
            </tr>
            <tr style="border-bottom: 1px solid #edf2f7;">
              <td style="padding: 0.6rem 0.8rem; font-weight: 700;">Aguinaldo</td>
              <td style="padding: 0.6rem 0.8rem;">Sueldo + Prestaciones</td>
              <td style="padding: 0.6rem 0.8rem;">15 días / 30 días</td>
              <td style="padding: 0.6rem 0.8rem;">$12.00</td>
              <td style="padding: 0.6rem 0.8rem; font-weight: 700; color: #1d6bc0;">$74.07</td>
            </tr>
            <tr style="border-bottom: 1px solid #edf2f7;">
              <td style="padding: 0.6rem 0.8rem; font-weight: 700;">Fondo de Ahorro</td>
              <td style="padding: 0.6rem 0.8rem;">Sueldo + Prestaciones</td>
              <td style="padding: 0.6rem 0.8rem;">13%</td>
              <td style="padding: 0.6rem 0.8rem;">--</td>
              <td style="padding: 0.6rem 0.8rem; font-weight: 700; color: #1d6bc0;">$115.54</td>
            </tr>
            <tr style="border-bottom: 1px solid #edf2f7;">
              <td style="padding: 0.6rem 0.8rem; font-weight: 700;">Prima Vacacional</td>
              <td style="padding: 0.6rem 0.8rem;">Sueldo + Prestaciones</td>
              <td style="padding: 0.6rem 0.8rem;">12 días 25%</td>
              <td style="padding: 0.6rem 0.8rem;">--</td>
              <td style="padding: 0.6rem 0.8rem; font-weight: 700; color: #1d6bc0;">$454.28</td>
            </tr>
            <tr>
              <td style="padding: 0.6rem 0.8rem; font-weight: 700;">Vales Despensa</td>
              <td style="padding: 0.6rem 0.8rem;">Sueldo + Prestaciones</td>
              <td style="padding: 0.6rem 0.8rem;">10%</td>
              <td style="padding: 0.6rem 0.8rem;">--</td>
              <td style="padding: 0.6rem 0.8rem; font-weight: 700; color: #1d6bc0;">$88.88</td>
            </tr>
          </tbody>
        </table>
      </div>
    `
  }
};

export function initScreenshotViewer() {
  const tabs = document.querySelectorAll('.shot-selector-bar .shot-tab');
  const appTitle = document.querySelector('#shot-app-title');
  const appStatus = document.querySelector('#shot-app-status');
  const displayContainer = document.querySelector('#shot-display-container');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const key = tab.getAttribute('data-shot');
      if (!key || !SCREENSHOT_VIEWS[key]) return;

      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const data = SCREENSHOT_VIEWS[key];

      if (appTitle) appTitle.textContent = data.title;
      if (appStatus) appStatus.textContent = data.status;
      if (displayContainer) displayContainer.innerHTML = data.content;
    });
  });
}
